// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   SETTINGS MODAL — BugReportModal-style overlay
   Content styles come from ../pages/Settings.css
   ============================================ */

.sm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: smFadeIn 0.15s ease-out;
}

@keyframes smFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.sm-modal {
  background: #111111;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  width: 92%;
  max-width: 540px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.04);
  animation: smSlideUp 0.2s ease-out;
}

@keyframes smSlideUp {
  from { opacity: 0; transform: translateY(16px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* --- Header --- */

.sm-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.sm-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #e5e7eb;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.sm-close {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #4b5563;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.12s;
  flex-shrink: 0;
  margin-left: auto;
}

.sm-close:hover {
  color: #d1d5db;
  background: rgba(255, 255, 255, 0.06);
}

/* --- Scrollable body --- */

.sm-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.75rem 1rem 1rem;
}

.sm-body::-webkit-scrollbar {
  width: 4px;
}
.sm-body::-webkit-scrollbar-track {
  background: transparent;
}
.sm-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

/* --- Override settings-page styles for modal context --- */

.sm-body .settings-section {
  margin-bottom: 1.25rem;
}

.sm-body .settings-section:last-child {
  margin-bottom: 0;
}

.sm-body .settings-card {
  padding: var(--space-4, 1rem);
}

.sm-body .section-label {
  margin-bottom: 0.5rem;
}

.sm-setting-divider {
  width: 100%;
  height: 1px;
  margin: 0.75rem 0 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), transparent);
}

.sm-toggle-row {
  width: 100%;
  margin-top: 0.75rem;
  padding: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  background: none;
  border: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.sm-toggle-copy {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.sm-toggle-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #f3f4f6;
}

.sm-toggle-description {
  font-size: 0.8rem;
  line-height: 1.45;
  color: #9ca3af;
}

.sm-toggle-meta {
  font-size: 0.72rem;
  line-height: 1.4;
  color: #6b7280;
}

.sm-toggle-switch {
  width: 44px;
  height: 26px;
  margin-top: 0.1rem;
  padding: 3px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: background 0.15s ease, border-color 0.15s ease;
}

.sm-toggle-switch.is-on {
  background: rgba(239, 68, 68, 0.24);
  border-color: rgba(239, 68, 68, 0.42);
}

.sm-toggle-thumb {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #f9fafb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
  transform: translateX(0);
  transition: transform 0.15s ease;
}

.sm-toggle-switch.is-on .sm-toggle-thumb {
  transform: translateX(18px);
}

/* --- Legal section override --- */
.sm-body .sm-legal {
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.sm-body .sm-legal h3 {
  font-size: 0.65rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 0.5rem 0;
}

.sm-body .sm-legal a {
  color: #4b5563;
  font-size: 0.75rem;
  text-decoration: none;
  transition: color 0.12s;
}

.sm-body .sm-legal a:hover {
  color: #9ca3af;
}

@media (max-width: 1800px) {
  .sm-overlay {
    padding: 16px;
  }

  .sm-modal {
    max-width: 500px;
    max-height: 82vh;
    border-radius: 12px;
  }

  .sm-header {
    padding: 0.75rem 0.9rem;
  }

  .sm-title {
    font-size: 0.78rem;
  }

  .sm-body {
    padding: 0.65rem 0.9rem 0.9rem;
  }

  .sm-body .settings-section {
    margin-bottom: 1rem;
  }

  .sm-body .settings-card {
    padding: 0.85rem;
  }

  .sm-toggle-row {
    margin-top: 0.65rem;
    gap: 0.85rem;
  }

  .sm-toggle-copy {
    gap: 0.3rem;
  }

  .sm-toggle-title {
    font-size: 0.9rem;
  }

  .sm-toggle-description {
    font-size: 0.76rem;
  }
}

@media (max-width: 600px) {
  .sm-modal {
    width: 96%;
    max-height: 90vh;
    border-radius: 12px;
  }

  .sm-body .settings-card {
    padding: var(--space-3, 0.75rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+EAA+E;EAC/E,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA,4BAA4B;;AAE5B;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":["/* ============================================\n   SETTINGS MODAL — BugReportModal-style overlay\n   Content styles come from ../pages/Settings.css\n   ============================================ */\n\n.sm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(6px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: smFadeIn 0.15s ease-out;\n}\n\n@keyframes smFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.sm-modal {\n  background: #111111;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  width: 92%;\n  max-width: 540px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.04);\n  animation: smSlideUp 0.2s ease-out;\n}\n\n@keyframes smSlideUp {\n  from { opacity: 0; transform: translateY(16px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* --- Header --- */\n\n.sm-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.sm-title {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #e5e7eb;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.sm-close {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: #4b5563;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.12s;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.sm-close:hover {\n  color: #d1d5db;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n/* --- Scrollable body --- */\n\n.sm-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.75rem 1rem 1rem;\n}\n\n.sm-body::-webkit-scrollbar {\n  width: 4px;\n}\n.sm-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.sm-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n/* --- Override settings-page styles for modal context --- */\n\n.sm-body .settings-section {\n  margin-bottom: 1.25rem;\n}\n\n.sm-body .settings-section:last-child {\n  margin-bottom: 0;\n}\n\n.sm-body .settings-card {\n  padding: var(--space-4, 1rem);\n}\n\n.sm-body .section-label {\n  margin-bottom: 0.5rem;\n}\n\n.sm-setting-divider {\n  width: 100%;\n  height: 1px;\n  margin: 0.75rem 0 0;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), transparent);\n}\n\n.sm-toggle-row {\n  width: 100%;\n  margin-top: 0.75rem;\n  padding: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  background: none;\n  border: none;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.sm-toggle-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.sm-toggle-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #f3f4f6;\n}\n\n.sm-toggle-description {\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: #9ca3af;\n}\n\n.sm-toggle-meta {\n  font-size: 0.72rem;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.sm-toggle-switch {\n  width: 44px;\n  height: 26px;\n  margin-top: 0.1rem;\n  padding: 3px;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.sm-toggle-switch.is-on {\n  background: rgba(239, 68, 68, 0.24);\n  border-color: rgba(239, 68, 68, 0.42);\n}\n\n.sm-toggle-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #f9fafb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);\n  transform: translateX(0);\n  transition: transform 0.15s ease;\n}\n\n.sm-toggle-switch.is-on .sm-toggle-thumb {\n  transform: translateX(18px);\n}\n\n/* --- Legal section override --- */\n.sm-body .sm-legal {\n  margin-top: 0.5rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.sm-body .sm-legal h3 {\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin: 0 0 0.5rem 0;\n}\n\n.sm-body .sm-legal a {\n  color: #4b5563;\n  font-size: 0.75rem;\n  text-decoration: none;\n  transition: color 0.12s;\n}\n\n.sm-body .sm-legal a:hover {\n  color: #9ca3af;\n}\n\n@media (max-width: 1800px) {\n  .sm-overlay {\n    padding: 16px;\n  }\n\n  .sm-modal {\n    max-width: 500px;\n    max-height: 82vh;\n    border-radius: 12px;\n  }\n\n  .sm-header {\n    padding: 0.75rem 0.9rem;\n  }\n\n  .sm-title {\n    font-size: 0.78rem;\n  }\n\n  .sm-body {\n    padding: 0.65rem 0.9rem 0.9rem;\n  }\n\n  .sm-body .settings-section {\n    margin-bottom: 1rem;\n  }\n\n  .sm-body .settings-card {\n    padding: 0.85rem;\n  }\n\n  .sm-toggle-row {\n    margin-top: 0.65rem;\n    gap: 0.85rem;\n  }\n\n  .sm-toggle-copy {\n    gap: 0.3rem;\n  }\n\n  .sm-toggle-title {\n    font-size: 0.9rem;\n  }\n\n  .sm-toggle-description {\n    font-size: 0.76rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .sm-modal {\n    width: 96%;\n    max-height: 90vh;\n    border-radius: 12px;\n  }\n\n  .sm-body .settings-card {\n    padding: var(--space-3, 0.75rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
